exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-style {\n  text-align: center !important;\n  color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/common-component/permission-denied/permission-denied.component.scss
// module id = ../../../../../src/app/common-component/permission-denied/permission-denied.component.scss
// module chunks = main